import React, { createContext, useContext, useState } from 'react';

export const Mode = createContext();

export default function DarkMode(props) {
  const [mode, setMode] = useState('light');

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      document.body.style.color = 'black';
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      document.body.style.color = 'black';
    }
  };

  return <Mode.Provider value={{ toggleMode }}>{props.children}</Mode.Provider>;
}

export const useMode = () => {
  return useContext(Mode);
};
